import type { Customer } from '@shared/types/customers'

export const mockCustomers: Customer[] = [
  {
    id: 'cust_001',
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '+1-555-0123',
    location: 'New York, NY',
    status: 'active',
    totalSpent: 15420.50,
    paymentCount: 12,
    lastPayment: '2024-01-15T10:30:00Z',
    lastActivity: '2024-01-20T10:30:00Z',
    created: '2023-06-15T08:00:00Z',
    verified: true,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'John Doe',
    refunds: 150.00,
    refundCount: 2,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'individual',
    delinquent: false,
    description: 'Premium individual customer',
    billingEmails: ['john.doe@example.com'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
  },
  {
    id: 'cust_002',
    name: 'Jane Smith',
    email: 'jane.smith@example.com',
    phone: '+1-555-0124',
    location: 'Los Angeles, CA',
    status: 'active',
    totalSpent: 8750.00,
    paymentCount: 8,
    lastPayment: '2024-01-10T14:20:00Z',
    lastActivity: '2024-01-18T14:20:00Z',
    created: '2023-08-20T12:00:00Z',
    verified: true,
    defaultPaymentMethod: 'PayPal',
    cardholderName: 'Jane Smith',
    refunds: 450.00,
    refundCount: 3,
    disputeLosses: 220.00,
    disputeCount: 1,
    type: 'individual',
    delinquent: false,
    description: 'Frequent buyer account',
    billingEmails: ['jane.smith@example.com'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
  },
  {
    id: 'cust_003',
    name: 'Bob Wilson',
    email: 'bob.wilson@example.com',
    phone: '+1-555-0125',
    location: 'Chicago, IL',
    status: 'under_review',
    reason: 'Suspicious transaction patterns',
    totalSpent: 25600.75,
    paymentCount: 18,
    lastPayment: '2024-01-12T09:15:00Z',
    lastActivity: '2024-01-16T09:15:00Z',
    created: '2023-04-10T14:30:00Z',
    verified: false,
    defaultPaymentMethod: 'Bank Transfer',
    cardholderName: 'Robert Wilson',
    refunds: 1200.00,
    refundCount: 5,
    disputeLosses: 890.00,
    disputeCount: 3,
    type: 'business',
    businessVatId: 'VAT123456789',
    delinquent: true,
    description: 'Enterprise B2B account',
    businessName: 'Wilson Enterprises',
    billingEmails: ['bob.wilson@example.com', 'billing@wilsonent.com'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['VAT123456789'],
  },
  {
    id: 'cust_004',
    name: 'Alice Johnson',
    email: 'alice.johnson@example.com',
    phone: '+1-555-0126',
    location: 'Houston, TX',
    status: 'restricted',
    reason: 'Multiple failed payments',
    totalSpent: 12300.25,
    paymentCount: 15,
    lastPayment: '2024-01-08T16:45:00Z',
    lastActivity: '2024-01-14T16:45:00Z',
    created: '2023-07-05T10:15:00Z',
    restricted: '2024-01-10T10:00:00Z',
    verified: true,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'Alice Johnson',
    refunds: 300.00,
    refundCount: 2,
    disputeLosses: 125.00,
    disputeCount: 1,
    type: 'individual',
    delinquent: true,
    description: 'Restricted due to payment failures',
    billingEmails: ['alice.johnson@example.com'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
  },
  {
    id: 'cust_005',
    name: 'Charlie Brown',
    email: 'charlie.brown@example.com',
    phone: '+1-555-0127',
    location: 'Phoenix, AZ',
    status: 'terminated',
    reason: 'Fraudulent activity detected',
    totalSpent: 5670.00,
    paymentCount: 5,
    lastPayment: '2023-12-20T11:30:00Z',
    lastActivity: '2023-12-25T11:30:00Z',
    created: '2023-05-12T13:45:00Z',
    terminated: '2024-01-05T09:00:00Z',
    verified: false,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'Charles Brown',
    refunds: 2300.00,
    refundCount: 8,
    disputeLosses: 1400.00,
    disputeCount: 4,
    type: 'individual',
    delinquent: true,
    description: 'Terminated - fraud detected',
    billingEmails: ['charlie.brown@example.com'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Not registered',
    taxStatus: 'Exempt',
  },
  {
    id: 'cust_006',
    name: 'Emma Davis',
    email: 'emma.davis@techstartup.com',
    phone: '+1-555-0128',
    location: 'San Francisco, CA',
    status: 'active',
    totalSpent: 45200.00,
    paymentCount: 32,
    lastPayment: '2024-01-22T15:30:00Z',
    lastActivity: '2024-01-23T09:15:00Z',
    created: '2023-03-08T11:20:00Z',
    verified: true,
    defaultPaymentMethod: 'Apple Pay',
    cardholderName: 'Emma Davis',
    refunds: 200.00,
    refundCount: 1,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    businessVatId: 'VAT987654321',
    delinquent: false,
    description: 'Tech startup - high volume',
    businessName: 'Davis Tech Startup',
    billingEmails: ['emma.davis@techstartup.com', 'finance@techstartup.com'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['VAT987654321'],
  },
  {
    id: 'cust_007',
    name: 'Michael Rodriguez',
    email: 'michael.r@globalcorp.com',
    phone: '+1-555-0129',
    location: 'Miami, FL',
    status: 'active',
    totalSpent: 18900.50,
    paymentCount: 25,
    lastPayment: '2024-01-18T12:45:00Z',
    lastActivity: '2024-01-21T14:20:00Z',
    created: '2023-01-15T09:30:00Z',
    verified: true,
    defaultPaymentMethod: 'Google Pay',
    cardholderName: 'Michael Rodriguez',
    refunds: 850.00,
    refundCount: 4,
    disputeLosses: 450.00,
    disputeCount: 2,
    type: 'business',
    businessVatId: 'VAT456789123',
    delinquent: false,
    description: 'Global corp account',
    businessName: 'Global Corp International',
    billingEmails: ['michael.r@globalcorp.com'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['VAT456789123'],
  },
  {
    id: 'cust_008',
    name: 'Sarah Thompson',
    email: 'sarah.thompson@freelance.net',
    phone: '+1-555-0130',
    location: 'Seattle, WA',
    status: 'under_review',
    reason: 'Unusual spending pattern',
    totalSpent: 7850.25,
    paymentCount: 12,
    lastPayment: '2024-01-19T16:20:00Z',
    lastActivity: '2024-01-20T10:45:00Z',
    created: '2023-09-22T14:15:00Z',
    verified: false,
    defaultPaymentMethod: 'Bank Transfer',
    cardholderName: 'Sarah Thompson',
    refunds: 125.00,
    refundCount: 1,
    disputeLosses: 75.00,
    disputeCount: 1,
    type: 'individual',
    delinquent: false,
    description: 'Freelancer under review',
    billingEmails: ['sarah.thompson@freelance.net'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Not registered',
    taxStatus: 'Taxable',
  },
  {
    id: 'cust_009',
    name: 'David Kim',
    email: 'david.kim@restaurant.biz',
    phone: '+1-555-0131',
    location: 'Denver, CO',
    status: 'restricted',
    reason: 'Chargebacks exceeded threshold',
    totalSpent: 31200.75,
    paymentCount: 45,
    lastPayment: '2024-01-11T11:30:00Z',
    lastActivity: '2024-01-15T13:25:00Z',
    created: '2023-02-28T10:45:00Z',
    restricted: '2024-01-12T14:00:00Z',
    verified: true,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'David Kim',
    refunds: 1800.00,
    refundCount: 12,
    disputeLosses: 2200.00,
    disputeCount: 8,
    type: 'business',
    businessVatId: 'VAT789123456',
    delinquent: true,
    description: 'Restaurant chain - restricted',
    businessName: "Kim's Kitchen Group",
    billingEmails: ['david.kim@restaurant.biz', 'accounting@restaurant.biz'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['VAT789123456'],
  },
  {
    id: 'cust_010',
    name: 'Lisa Wang',
    email: 'lisa.wang@consulting.pro',
    phone: '+1-555-0132',
    location: 'Boston, MA',
    status: 'active',
    totalSpent: 28500.00,
    paymentCount: 28,
    lastPayment: '2024-01-21T14:15:00Z',
    lastActivity: '2024-01-22T16:30:00Z',
    created: '2023-05-10T13:20:00Z',
    verified: true,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'Lisa Wang',
    refunds: 0,
    refundCount: 0,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    businessVatId: 'VAT321654987',
    delinquent: false,
    description: 'Consulting firm - premium tier',
    businessName: 'Wang Consulting Pro',
    billingEmails: ['lisa.wang@consulting.pro'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['VAT321654987'],
  },
  {
    id: 'cust_011',
    name: 'Oliver Bennett',
    email: 'o.bennett@bennett-retail.co.uk',
    phone: '+44-20-7946-0101',
    location: 'London, UK',
    status: 'active',
    totalSpent: 62400.00,
    paymentCount: 54,
    lastPayment: '2024-01-23T09:00:00Z',
    lastActivity: '2024-01-23T11:30:00Z',
    created: '2022-11-01T10:00:00Z',
    verified: true,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'Oliver Bennett',
    refunds: 320.00,
    refundCount: 2,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    businessVatId: 'GB123456789',
    delinquent: false,
    description: 'UK retail chain - long-term account',
    businessName: 'Bennett Retail Group',
    billingEmails: ['o.bennett@bennett-retail.co.uk', 'accounts@bennett-retail.co.uk'],
    billingCountry: 'United Kingdom',
    language: 'English (United Kingdom)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['GB123456789'],
  },
  {
    id: 'cust_012',
    name: 'Lena Hoffmann',
    email: 'lena.hoffmann@hoffmann-gmbh.de',
    phone: '+49-30-1234-5678',
    location: 'Berlin, Germany',
    status: 'active',
    totalSpent: 91250.50,
    paymentCount: 72,
    lastPayment: '2024-01-22T13:45:00Z',
    lastActivity: '2024-01-23T08:00:00Z',
    created: '2022-06-14T09:30:00Z',
    verified: true,
    defaultPaymentMethod: 'SEPA Direct Debit',
    cardholderName: 'Lena Hoffmann',
    refunds: 0,
    refundCount: 0,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    businessVatId: 'DE987654321',
    delinquent: false,
    description: 'German SaaS company - enterprise plan',
    businessName: 'Hoffmann GmbH',
    billingEmails: ['lena.hoffmann@hoffmann-gmbh.de', 'finanzen@hoffmann-gmbh.de'],
    billingCountry: 'Germany',
    language: 'German',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['DE987654321'],
  },
  {
    id: 'cust_013',
    name: 'Yuki Tanaka',
    email: 'yuki.tanaka@tanaka-holdings.jp',
    phone: '+81-3-1234-5678',
    location: 'Tokyo, Japan',
    status: 'active',
    totalSpent: 134800.00,
    paymentCount: 98,
    lastPayment: '2024-01-23T06:30:00Z',
    lastActivity: '2024-01-23T07:15:00Z',
    created: '2022-03-20T04:00:00Z',
    verified: true,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'Yuki Tanaka',
    refunds: 500.00,
    refundCount: 1,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    businessVatId: 'JP001234567',
    delinquent: false,
    description: 'Japanese holding company - enterprise',
    businessName: 'Tanaka Holdings',
    billingEmails: ['yuki.tanaka@tanaka-holdings.jp'],
    billingCountry: 'Japan',
    language: 'Japanese',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['JP001234567'],
  },
  {
    id: 'cust_014',
    name: 'Sofia Martins',
    email: 'sofia.martins@martins-ecom.com.br',
    phone: '+55-11-9876-5432',
    location: 'São Paulo, Brazil',
    status: 'active',
    reason: 'Elevated chargeback ratio',
    totalSpent: 22100.75,
    paymentCount: 30,
    lastPayment: '2024-01-17T19:00:00Z',
    lastActivity: '2024-01-20T21:10:00Z',
    created: '2023-04-15T13:00:00Z',
    verified: true,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'Sofia Martins',
    refunds: 980.00,
    refundCount: 6,
    disputeLosses: 540.00,
    disputeCount: 3,
    type: 'business',
    businessVatId: 'BR12345678000195',
    delinquent: false,
    description: 'Brazilian e-commerce operator',
    businessName: 'Martins E-Commerce',
    billingEmails: ['sofia.martins@martins-ecom.com.br'],
    billingCountry: 'Brazil',
    language: 'Portuguese (Brazil)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['BR12345678000195'],
  },
  {
    id: 'cust_015',
    name: 'Priya Nair',
    email: 'priya.nair@nairtech.in',
    phone: '+91-98765-43210',
    location: 'Bangalore, India',
    status: 'active',
    totalSpent: 18700.00,
    paymentCount: 20,
    lastPayment: '2024-01-20T07:30:00Z',
    lastActivity: '2024-01-22T08:45:00Z',
    created: '2023-07-11T06:00:00Z',
    verified: true,
    defaultPaymentMethod: 'UPI',
    cardholderName: 'Priya Nair',
    refunds: 150.00,
    refundCount: 1,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    businessVatId: 'IN27AABCU9603R1ZM',
    delinquent: false,
    description: 'Indian IT services company',
    businessName: 'NairTech Solutions',
    billingEmails: ['priya.nair@nairtech.in', 'billing@nairtech.in'],
    billingCountry: 'India',
    language: 'English (India)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['IN27AABCU9603R1ZM'],
  },
  {
    id: 'cust_016',
    name: 'Marcus Osei',
    email: 'marcus.osei@osei-logistics.gh',
    phone: '+233-30-999-0001',
    location: 'Accra, Ghana',
    status: 'under_review',
    reason: 'New high-value account pending KYC',
    totalSpent: 4200.00,
    paymentCount: 5,
    lastPayment: '2024-01-19T15:00:00Z',
    lastActivity: '2024-01-21T16:00:00Z',
    created: '2024-01-10T12:00:00Z',
    verified: false,
    defaultPaymentMethod: 'Mobile Money',
    cardholderName: 'Marcus Osei',
    refunds: 0,
    refundCount: 0,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    delinquent: false,
    description: 'West African logistics firm - new account',
    businessName: 'Osei Logistics Ltd',
    billingEmails: ['marcus.osei@osei-logistics.gh'],
    billingCountry: 'Ghana',
    language: 'English',
    taxLocationStatus: 'Not registered',
    taxStatus: 'Taxable',
  },
  {
    id: 'cust_017',
    name: 'Chloe Dupont',
    email: 'chloe.dupont@dupont-design.fr',
    phone: '+33-1-4567-8901',
    location: 'Paris, France',
    status: 'active',
    totalSpent: 37600.00,
    paymentCount: 41,
    lastPayment: '2024-01-22T11:00:00Z',
    lastActivity: '2024-01-23T10:20:00Z',
    created: '2023-01-09T09:00:00Z',
    verified: true,
    defaultPaymentMethod: 'SEPA Direct Debit',
    cardholderName: 'Chloe Dupont',
    refunds: 0,
    refundCount: 0,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    businessVatId: 'FR40303265045',
    delinquent: false,
    description: 'French design agency - steady account',
    businessName: 'Dupont Design Studio',
    billingEmails: ['chloe.dupont@dupont-design.fr', 'compta@dupont-design.fr'],
    billingCountry: 'France',
    language: 'French',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
    taxIds: ['FR40303265045'],
  },
  {
    id: 'cust_018',
    name: 'Nathan Kowalski',
    email: 'n.kowalski@kowalski-dev.pl',
    phone: '+48-22-123-4567',
    location: 'Warsaw, Poland',
    status: 'restricted',
    reason: 'Account suspended pending investigation',
    totalSpent: 9400.00,
    paymentCount: 14,
    lastPayment: '2024-01-05T10:00:00Z',
    lastActivity: '2024-01-07T11:30:00Z',
    created: '2023-10-03T08:00:00Z',
    verified: false,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'Nathan Kowalski',
    refunds: 1500.00,
    refundCount: 5,
    disputeLosses: 900.00,
    disputeCount: 3,
    type: 'individual',
    delinquent: true,
    description: 'Suspended - investigation in progress',
    billingEmails: ['n.kowalski@kowalski-dev.pl'],
    billingCountry: 'Poland',
    language: 'Polish',
    taxLocationStatus: 'Not registered',
    taxStatus: 'Taxable',
  },
  {
    id: 'cust_019',
    name: 'Amira Hassan',
    email: 'amira.hassan@hassan-pharma.ae',
    phone: '+971-4-321-0987',
    location: 'Dubai, UAE',
    status: 'active',
    totalSpent: 55000.00,
    paymentCount: 38,
    lastPayment: '2024-01-22T10:15:00Z',
    lastActivity: '2024-01-23T09:00:00Z',
    created: '2023-02-17T07:00:00Z',
    verified: true,
    defaultPaymentMethod: 'Credit Card',
    cardholderName: 'Amira Hassan',
    refunds: 200.00,
    refundCount: 1,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'business',
    businessVatId: 'AE100234567',
    delinquent: false,
    description: 'UAE pharmaceutical distributor',
    businessName: 'Hassan Pharma Distribution',
    billingEmails: ['amira.hassan@hassan-pharma.ae', 'finance@hassan-pharma.ae'],
    billingCountry: 'United Arab Emirates',
    language: 'English',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Exempt',
    taxIds: ['AE100234567'],
  },
  {
    id: 'cust_020',
    name: 'Tom Nguyen',
    email: 'tom.nguyen@nguyen-agency.com',
    phone: '+1-555-0145',
    location: 'Austin, TX',
    status: 'active',
    totalSpent: 11200.00,
    paymentCount: 16,
    lastPayment: '2024-01-21T17:00:00Z',
    lastActivity: '2024-01-23T12:00:00Z',
    created: '2023-08-05T14:00:00Z',
    verified: true,
    defaultPaymentMethod: 'Apple Pay',
    cardholderName: 'Tom Nguyen',
    refunds: 0,
    refundCount: 0,
    disputeLosses: 0,
    disputeCount: 0,
    type: 'individual',
    delinquent: false,
    description: 'Freelance marketing agency owner',
    billingEmails: ['tom.nguyen@nguyen-agency.com'],
    billingCountry: 'United States',
    language: 'English (United States)',
    taxLocationStatus: 'Recognized',
    taxStatus: 'Taxable',
  },
]
